// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__306h5","tab":"Tabs_tab__36k-v","tabActive":"Tabs_tabActive__U1Rau"};